/* Once More Wear — tema Maison. Nessuna dipendenza esterna. */
(() => {
  'use strict';
  const OMW = window.OMW || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  /* ---------------- denaro ---------------- */
  function formatMoney(cents) {
    const fmt = OMW.moneyFormat || '€{{amount_with_comma_separator}}';
    const value = (Number(cents) || 0) / 100;
    const group = (n, d, t, s) => {
      const [i, f] = n.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (d ? s + f : '');
    };
    const out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        default: return group(value, 2, '.', ',');
      }
    });
    return out.replace(/[.,]00(?!\d)/, '');
  }

  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const ease = (t) => (t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const store = { get(k) { try { return sessionStorage.getItem(k); } catch (_) { return null; } }, set(k, v) { try { sessionStorage.setItem(k, v); } catch (_) {} } };

  /* un solo ciclo di animazione per tutto il tema */
  const ticks = new Set();
  let ticking = false;
  const loop = (t) => { ticks.forEach((fn) => fn(t)); if (ticks.size) requestAnimationFrame(loop); else ticking = false; };
  const onTick = (fn) => { ticks.add(fn); if (!ticking) { ticking = true; requestAnimationFrame(loop); } return () => ticks.delete(fn); };

  /* ---------------- header ---------------- */
  const header = $('[data-header]');
  const stageEl = $('[data-stage]');
  if (header) {
    let lastY = window.scrollY;
    const update = () => {
      const y = window.scrollY;
      const h = header.offsetHeight;
      header.classList.toggle('is-stuck', y > 4);
      if (stageEl) {
        const end = stageEl.offsetTop + stageEl.offsetHeight - h;
        header.classList.toggle('is-over', y < end);
      }
      const goingDown = y > lastY + 2;
      const goingUp = y < lastY - 2;
      if (goingDown && y > h * 2) header.classList.add('is-hidden');
      else if (goingUp || y < h) header.classList.remove('is-hidden');
      document.documentElement.classList.toggle('header-hidden', header.classList.contains('is-hidden'));
      lastY = y;
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    header.addEventListener('focusin', () => header.classList.remove('is-hidden'));
  }

  /* ---------------- palcoscenico ---------------- */
  if (stageEl) {
    const sticky = $('[data-stage-sticky]', stageEl);
    const frame = $('[data-stage-frame]', stageEl);
    const slides = $$('.stage__slide', stageEl);
    const captions = $$('.stage__caption', stageEl);
    const dots = $$('[data-stage-dot]', stageEl);
    const sides = $$('[data-stage-side]', stageEl);
    const pauseBtn = $('[data-stage-pause]', stageEl);
    const n = slides.length;
    const dur = (Number(stageEl.dataset.autoplay) || 5) * 1000;
    let idx = 0, elapsed = 0, last = 0, paused = REDUCED, hovering = false, prevTimer = null;
    let geo = { W: 0, H: 0, fw0: 0, fh0: 0, fy0: 0 };
    let mx = 0, my = 0, tx = 0, ty = 0, progress = 0;

    const measure = () => {
      const W = sticky.clientWidth, H = sticky.clientHeight;
      const cs = getComputedStyle(sticky);
      // misura la cornice di partenza dalle variabili CSS
      const probe = document.createElement('div');
      probe.style.cssText = 'position:absolute;visibility:hidden;width:var(--fw0);height:var(--fh0);top:var(--fy0);left:0';
      sticky.appendChild(probe);
      const r = probe.getBoundingClientRect(), sr = sticky.getBoundingClientRect();
      geo = { W, H, fw0: r.width, fh0: r.height, fy0: r.top - sr.top };
      probe.remove();
      return cs;
    };
    const setSides = () => {
      sides.forEach((side) => {
        const k = (idx + Number(side.dataset.stageSide) + n) % n;
        $$('.stage__thumb', side).forEach((t) => t.classList.toggle('is-on', Number(t.dataset.i) === k));
      });
    };
    const go = (to, user) => {
      if (!n) return;
      to = (to + n) % n;
      if (to === idx) return;
      const from = idx;
      slides.forEach((s, i) => {
        s.classList.toggle('is-prev', i === from);
        s.classList.toggle('is-active', i === to);
        if (i === to) { s.removeAttribute('tabindex'); s.removeAttribute('aria-hidden'); }
        else { s.setAttribute('tabindex', '-1'); s.setAttribute('aria-hidden', 'true'); }
      });
      clearTimeout(prevTimer);
      prevTimer = setTimeout(() => slides.forEach((s) => s.classList.remove('is-prev')), 1300);
      captions.forEach((c, i) => { c.hidden = i !== to; c.classList.toggle('is-active', i === to); });
      dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === to);
        d.classList.toggle('is-done', i < to);
        if (i === to) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        d.style.removeProperty('--t');
      });
      idx = to; elapsed = 0;
      setSides();
      if (user && !paused) elapsed = 0;
    };
    setSides();

    const tick = (t) => {
      const dt = last ? Math.min(64, t - last) : 16; last = t;
      // avanzamento automatico
      if (n > 1 && !paused && !hovering && progress < .02 && !document.hidden) {
        elapsed += dt;
        if (dots[idx]) dots[idx].style.setProperty('--t', clamp(elapsed / dur, 0, 1).toFixed(3));
        if (elapsed >= dur) go(idx + 1);
      }
      // scorrimento: la cornice si apre a tutto schermo
      const rect = stageEl.getBoundingClientRect();
      const span = Math.max(1, stageEl.offsetHeight - geo.H);
      progress = REDUCED ? 0 : clamp(-rect.top / span, 0, 1);
      const e = ease(progress);
      // parallasse del puntatore
      mx = lerp(mx, tx * (1 - e), .07); my = lerp(my, ty * (1 - e), .07);
      const st = sticky.style;
      st.setProperty('--p', progress.toFixed(4));
      st.setProperty('--e', e.toFixed(4));
      st.setProperty('--sp', clamp((progress - .62) / .3, 0, 1).toFixed(3));
      st.setProperty('--fw', `${lerp(geo.fw0, geo.W, e).toFixed(1)}px`);
      st.setProperty('--fh', `${lerp(geo.fh0, geo.H, e).toFixed(1)}px`);
      st.setProperty('--fy', `${lerp(geo.fy0, geo.H / 2, e).toFixed(1)}px`);
      st.setProperty('--mx', mx.toFixed(4)); st.setProperty('--my', my.toFixed(4));
      st.setProperty('--ox', `${(mx * -9).toFixed(2)}px`); st.setProperty('--oy', `${(my * -7).toFixed(2)}px`);
    };

    const start = () => {
      measure();
      onTick(tick);
      const quick = store.get('omw-stage') === '1';
      if (quick) stageEl.classList.add('is-quick');
      requestAnimationFrame(() => { stageEl.classList.add('is-ready', 'is-in'); });
      store.set('omw-stage', '1');
    };
    (document.fonts && document.fonts.ready ? Promise.race([document.fonts.ready, new Promise((r) => setTimeout(r, 900))]) : Promise.resolve()).then(start);
    window.addEventListener('resize', () => measure());

    if (FINE) {
      stageEl.addEventListener('pointermove', (ev) => {
        tx = (ev.clientX / window.innerWidth) * 2 - 1;
        ty = (ev.clientY / window.innerHeight) * 2 - 1;
      });
      stageEl.addEventListener('pointerleave', () => { tx = 0; ty = 0; });
    }
    frame.addEventListener('pointerenter', () => { hovering = FINE; });
    frame.addEventListener('pointerleave', () => { hovering = false; });
    stageEl.addEventListener('focusin', () => { hovering = true; });
    stageEl.addEventListener('focusout', () => { hovering = false; });

    // scorrimento con il dito sulla cornice
    let sx = null, sy = null, swiped = false;
    frame.addEventListener('pointerdown', (ev) => { if (ev.pointerType === 'mouse') return; sx = ev.clientX; sy = ev.clientY; swiped = false; });
    frame.addEventListener('pointerup', (ev) => {
      if (sx === null) return;
      const dx = ev.clientX - sx, dy = ev.clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) { swiped = true; go(idx + (dx < 0 ? 1 : -1), true); }
      sx = null;
    });
    frame.addEventListener('click', (ev) => { if (swiped) { ev.preventDefault(); swiped = false; } }, true);

    sides.forEach((side) => side.addEventListener('click', () => go(idx + Number(side.dataset.stageSide), true)));
    $$('[data-stage-go]', stageEl).forEach((b) => b.addEventListener('click', () => go(idx + Number(b.dataset.stageGo), true)));
    dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.stageDot), true)));
    if (pauseBtn) {
      const label = $('.visually-hidden', pauseBtn);
      const sync = () => { pauseBtn.setAttribute('aria-pressed', String(paused)); label.textContent = paused ? 'Riprendi lo scorrimento automatico' : 'Ferma lo scorrimento automatico'; };
      sync();
      pauseBtn.addEventListener('click', () => { paused = !paused; sync(); });
    }
  }

  /* ---------------- cassetti e pannelli ---------------- */
  const LAYERS = '.drawer, .search-panel, .lightbox';
  const OPEN = '.drawer.is-open, .search-panel.is-open, .lightbox.is-open';
  let lastTrigger = null;
  const focusables = (el) => $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]', el)
    .filter((n) => n.getAttribute('tabindex') !== '-1' && (n.offsetParent !== null || n === document.activeElement));

  function openLayer(el, trigger) {
    if (!el) return;
    lastTrigger = trigger || document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-open'));
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
    $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const target = $('[data-autofocus]', el) || focusables(el)[0];
    setTimeout(() => target && target.focus(), 60);
  }
  function closeLayer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!$(OPEN)) document.documentElement.classList.remove('is-locked');
    setTimeout(() => { if (!el.classList.contains('is-open')) el.hidden = true; }, 420);
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open]');
    if (open) { e.preventDefault(); openLayer(document.getElementById(open.dataset.open), open); return; }
    const close = e.target.closest('[data-close]');
    if (close) { e.preventDefault(); closeLayer(close.closest(LAYERS) || document.getElementById(close.dataset.close)); }
  });
  document.addEventListener('keydown', (e) => {
    const layer = $(OPEN);
    if (!layer) return;
    if (e.key === 'Escape') { e.preventDefault(); closeLayer(layer); return; }
    if (e.key === 'Tab') {
      const f = focusables(layer);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  const searchScrim = $('[data-search-scrim]');
  const searchPanel = $('#SearchPanel');
  if (searchPanel && searchScrim) {
    new MutationObserver(() => { searchScrim.hidden = !searchPanel.classList.contains('is-open'); }).observe(searchPanel, { attributes: true, attributeFilter: ['class'] });
    searchScrim.addEventListener('click', () => closeLayer(searchPanel));
  }

  /* ---------------- ricerca istantanea ---------------- */
  const searchInput = $('[data-predictive-input]');
  const searchOut = $('[data-predictive-results]');
  if (searchInput && searchOut) {
    let t = null; let ctrl = null;
    searchInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchOut.innerHTML = ''; return; }
      t = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${OMW.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=5&section_id=predictive-search`;
          const res = await fetch(url, { signal: ctrl.signal });
          if (!res.ok) throw new Error(res.status);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = $('[data-predictive-inner]', doc);
          searchOut.innerHTML = inner ? inner.innerHTML : '';
        } catch (err) { if (err.name !== 'AbortError') searchOut.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------------- carrello ---------------- */
  const cartDrawer = $('#CartDrawer');
  const cartLive = $('[data-cart-live]');

  async function refreshCart(sectionsJson) {
    let html = sectionsJson && sectionsJson['cart-drawer'];
    if (!html) {
      const res = await fetch(`${OMW.routes.root}?sections=cart-drawer`);
      html = (await res.json())['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-cart-inner]', doc);
    const current = $('[data-cart-inner]');
    if (fresh && current) current.replaceWith(fresh);
    const count = fresh ? fresh.dataset.count : null;
    if (count !== null) {
      $$('[data-cart-count]').forEach((n) => { n.textContent = count; });
      if (cartLive) cartLive.textContent = `${OMW.strings.cartCount}: ${count}`;
    }
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || OMW.cartType !== 'drawer') return;
    e.preventDefault();
    const btn = (e.submitter && form.contains(e.submitter)) ? e.submitter : $('[type="submit"]', form);
    const err = $('[data-form-error]', form);
    if (err) { err.hidden = true; err.textContent = ''; }
    btn && btn.classList.add('is-loading');
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      const res = await fetch(OMW.routes.cartAdd, { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok || data.status) {
        if (err) { err.textContent = data.description || data.message || OMW.strings.addError; err.hidden = false; }
        return;
      }
      await refreshCart(data.sections);
      $$('[data-cart-count]').forEach((n) => { n.parentElement.classList.remove('is-bump'); void n.offsetWidth; n.parentElement.classList.add('is-bump'); });
      if (btn) { btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1600); }
      openLayer(cartDrawer, btn);
    } catch (_) {
      if (err) { err.textContent = OMW.strings.addError; err.hidden = false; }
    } finally {
      btn && btn.classList.remove('is-loading');
      btn && btn.removeAttribute('aria-busy');
    }
  });

  async function changeLine(line, quantity, scope) {
    scope && scope.classList.add('is-loading');
    try {
      const res = await fetch(OMW.routes.cartChange, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: ['cart-drawer'] })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message);
      if (document.body.classList.contains('t-cart')) { window.location.reload(); return; }
      await refreshCart(data.sections);
    } catch (e) {
      const msg = $('[data-cart-error]');
      if (msg) { msg.textContent = e.message || OMW.strings.cartError; msg.hidden = false; }
    } finally { scope && scope.classList.remove('is-loading'); }
  }
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-line-step]');
    if (step) {
      const input = $(`[data-line-qty="${step.dataset.line}"]`, step.closest('[data-cart-root]') || document);
      const next = Math.max(0, Number(input.value) + Number(step.dataset.lineStep));
      input.value = next;
      changeLine(step.dataset.line, next, step.closest('.line'));
      return;
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.lineRemove, 0, rm.closest('.line')); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) changeLine(input.dataset.lineQty, Math.max(0, Number(input.value) || 0), input.closest('.line'));
  });

  /* ---------------- quantità nella scheda ---------------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = $('input', b.closest('.qty'));
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    input.value = Math.min(max, Math.max(min, (Number(input.value) || min) + Number(b.dataset.qtyStep)));
  });

  /* ---------------- varianti ---------------- */
  $$('[data-product]').forEach((root) => {
    const json = $('[data-product-json]', root);
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = form && $('input[name="id"]', form);
    const priceEl = $('[data-price]', root);
    const btn = form && $('[data-add-button]', form);
    const btnText = btn && $('span', btn);
    const inputs = $$('[data-option-input]', root);

    function current() {
      const chosen = [1, 2, 3].map((i) => {
        const checked = inputs.find((n) => n.dataset.position === String(i) && n.checked);
        return checked ? checked.value : null;
      }).filter((v) => v !== null);
      return product.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    }
    function markAvailability() {
      inputs.forEach((input) => {
        const pos = Number(input.dataset.position) - 1;
        const others = inputs.filter((n) => n.checked && n.dataset.position !== input.dataset.position);
        const ok = product.variants.some((v) => v.available && v.options[pos] === input.value &&
          others.every((o) => v.options[Number(o.dataset.position) - 1] === o.value));
        input.classList.toggle('is-unavailable', !ok);
      });
    }
    function update() {
      const v = current();
      markAvailability();
      if (!v) {
        if (btn) { btn.disabled = true; btnText.textContent = OMW.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        priceEl.classList.toggle('price--sale', !!sale);
        priceEl.innerHTML = (sale ? `<s class="price__compare"><span class="visually-hidden">${OMW.strings.was} </span>${formatMoney(v.compare_at_price)}</s>` : '') +
          `<span class="price__now">${sale ? `<span class="visually-hidden">${OMW.strings.now} </span>` : ''}${formatMoney(v.price)}</span>`;
      }
      if (btn) { btn.disabled = !v.available; btnText.textContent = v.available ? OMW.strings.addToCart : OMW.strings.soldOut; }
      const bb = $('[data-buybar-btn]', root), bp = $('[data-buybar-price]', root);
      if (bb) { bb.disabled = !v.available; bb.textContent = v.available ? 'Aggiungi' : OMW.strings.soldOut; }
      if (bp) bp.textContent = formatMoney(v.price);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.featured_media_id) {
        const media = $(`[data-media-id="${v.featured_media_id}"]`, root);
        if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }
    inputs.forEach((n) => n.addEventListener('change', update));
    markAvailability();
  });

  /* ---------------- barra d'acquisto su mobile ---------------- */
  $$('[data-buybar]').forEach((bar) => {
    const main = $('[data-add-button]', bar.closest('form'));
    if (!main) return;
    const check = () => bar.classList.toggle('is-on', main.getBoundingClientRect().bottom < 0);
    window.addEventListener('scroll', check, { passive: true });
    check();
  });

  /* ---------------- galleria ---------------- */
  $$('[data-gallery]').forEach((g) => {
    const track = $('.gallery__track', g);
    const count = $('[data-gallery-count]', g);
    const items = $$('.gallery__item', g);
    const prog = $('[data-gallery-progress]', g);
    if (track && count && items.length > 1) {
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        count.textContent = `${Math.min(items.length, i + 1)} / ${items.length}`;
        if (prog) prog.style.setProperty('--g', clamp(track.scrollLeft / track.clientWidth, 0, items.length - 1).toFixed(3));
      }, { passive: true });
    }
    // lente: la foto si ingrandisce sotto il puntatore
    if (FINE) {
      items.forEach((it) => {
        const img = $('img', it);
        if (!img) return;
        it.addEventListener('pointermove', (ev) => {
          if (window.innerWidth < 900) return;
          const r = it.getBoundingClientRect();
          img.style.transformOrigin = `${((ev.clientX - r.left) / r.width * 100).toFixed(1)}% ${((ev.clientY - r.top) / r.height * 100).toFixed(1)}%`;
          it.classList.add('is-zoom');
        });
        it.addEventListener('pointerleave', () => it.classList.remove('is-zoom'));
      });
    }
    const box = $('[data-lightbox]', g.closest('[data-product]') || document);
    $$('[data-zoom]', g).forEach((b) => b.addEventListener('click', () => {
      if (!box) return;
      openLayer(box, b);
      const target = $(`[data-lightbox-item="${b.dataset.zoom}"]`, box);
      if (target) setTimeout(() => target.scrollIntoView({ block: 'start' }), 80);
    }));
  });

  /* ---------------- comparse allo scroll (anche per contenuti caricati dopo) ---------------- */
  $$('main .h-section').forEach((h) => { if (!h.closest('.stage, .drawer, .search-panel')) h.setAttribute('data-reveal', ''); });
  const revealIO = ('IntersectionObserver' in window && !REDUCED) ? new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const el = en.target;
      const row = el.closest('ul, .grid, .collections-list');
      if (row && el.dataset.reveal === 'media') {
        const sibs = $$('[data-reveal="media"]', row).filter((x) => !x.classList.contains('is-shown'));
        el.style.setProperty('--rd', `${Math.min(Math.max(0, sibs.indexOf(el)), 4) * 0.09}s`);
      }
      el.classList.add('is-shown');
      revealIO.unobserve(el);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 }) : null;
  const watchReveal = (root) => {
    $$('[data-reveal]:not(.is-shown)', root).forEach((el) => { if (revealIO) revealIO.observe(el); else el.classList.add('is-shown'); });
  };
  watchReveal(document);
  if ('MutationObserver' in window) {
    new MutationObserver((muts) => {
      muts.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) { if (n.matches('[data-reveal]')) watchReveal(n.parentElement || document); else watchReveal(n); } }));
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------- frase che si accende ---------------- */
  $$('[data-manifesto]').forEach((sec) => {
    const words = $$('.mf__w', sec);
    if (!words.length) return;
    if (REDUCED) { words.forEach((w) => w.classList.add('is-lit')); return; }
    let lit = -1;
    onTick(() => {
      const r = sec.getBoundingClientRect();
      const vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      const p = clamp((vh * 0.82 - r.top) / (r.height * 0.9), 0, 1);
      const k = Math.round(p * words.length);
      if (k === lit) return;
      lit = k;
      words.forEach((w, i) => w.classList.toggle('is-lit', i < k));
    });
  });

  /* ---------------- scritta che passa dietro la foto ---------------- */
  $$('[data-overlap]').forEach((sec) => {
    const text = $('[data-overlap-text]', sec), media = $('[data-overlap-media]', sec), line = $('[data-overlap-line]', sec);
    if (!text || !media || !line) return;
    const align = () => {
      const t = text.getBoundingClientRect(), m = media.getBoundingClientRect();
      line.style.width = `${t.width}px`;
      line.style.transform = `translate(${(t.left - m.left).toFixed(1)}px, ${(t.top - m.top).toFixed(1)}px)`;
      line.style.textAlign = getComputedStyle(text).textAlign;
    };
    align();
    window.addEventListener('resize', align);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(align);
    if ('ResizeObserver' in window) new ResizeObserver(align).observe(sec);
  });

  /* ---------------- parallasse ---------------- */
  $$('[data-parallax]').forEach((el) => {
    if (REDUCED) return;
    onTick(() => {
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight;
      if (r.bottom < -100 || r.top > vh + 100) return;
      const p = (r.top + r.height / 2 - vh / 2) / vh; // -1 … 1
      el.style.setProperty('--py', `${(p * -7).toFixed(2)}%`);
    });
  });

  /* ---------------- nastro di foto ---------------- */
  $$('[data-marquee]').forEach((mq) => {
    const track = $('[data-marquee-track]', mq);
    if (!track || REDUCED) return;
    const base = Number(mq.dataset.speed) || 35; // px al secondo
    let x = 0, last = 0, boost = 0, dir = 1, hover = false, lastY = window.scrollY, w = track.offsetWidth;
    window.addEventListener('resize', () => { w = track.offsetWidth; });
    window.addEventListener('scroll', () => {
      const y = window.scrollY; const d = y - lastY; lastY = y;
      if (Math.abs(d) > 1) { dir = d > 0 ? 1 : -1; boost = Math.min(18, boost + Math.abs(d) * 0.08); }
    }, { passive: true });
    if (FINE) { mq.addEventListener('pointerenter', () => { hover = true; }); mq.addEventListener('pointerleave', () => { hover = false; }); }
    mq.addEventListener('focusin', () => { hover = true; });
    mq.addEventListener('focusout', () => { hover = false; });
    onTick((t) => {
      const dt = last ? Math.min(64, t - last) / 1000 : 0; last = t;
      const r = mq.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      boost *= 0.94;
      const v = hover ? 0 : base * (1 + boost) * dir;
      x -= v * dt;
      if (x <= -w) x += w;
      if (x > 0) x -= w;
      mq.style.transform = `translate3d(${x.toFixed(2)}px,0,0)`;
    });
  });

  /* ---------------- caroselli ---------------- */
  $$('[data-rail]').forEach((rail) => {
    const track = $('[data-rail-track]', rail);
    const bar = $('[data-rail-bar]', rail);
    const sec = rail.closest('section');
    const prev = $('[data-rail-prev]', sec), next = $('[data-rail-next]', sec);
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const vis = track.clientWidth / track.scrollWidth;
      const p = max > 0 ? track.scrollLeft / max : 1;
      if (bar) bar.parentElement.style.setProperty('--rail', Math.max(vis, vis + (1 - vis) * p).toFixed(3));
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    };
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    const step = () => { const item = $('.rail__item', track); return item ? item.getBoundingClientRect().width + 24 : track.clientWidth * .8; };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step() * (window.innerWidth > 1100 ? 2 : 1), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step() * (window.innerWidth > 1100 ? 2 : 1), behavior: 'smooth' }));
    track.addEventListener('keydown', (e) => {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
    });
    // trascinamento con il mouse, con inerzia
    if (!FINE) return;
    let down = false, sx = 0, sl = 0, moved = 0, vx = 0, lx = 0, lt = 0, inertia = null;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = 0; sx = e.clientX; sl = track.scrollLeft; lx = e.clientX; lt = performance.now(); vx = 0;
      if (inertia) { inertia(); inertia = null; }
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
      if (moved > 6) rail.classList.add('is-dragging');
      track.scrollLeft = sl - dx;
      const now = performance.now(); vx = (e.clientX - lx) / Math.max(1, now - lt); lx = e.clientX; lt = now;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return; down = false;
      let v = -vx * 16;
      inertia = onTick(() => {
        v *= 0.93; track.scrollLeft += v;
        if (Math.abs(v) < 0.4) { inertia && inertia(); inertia = null; requestAnimationFrame(() => rail.classList.remove('is-dragging')); }
      });
      if (moved <= 6) rail.classList.remove('is-dragging');
    });
    track.addEventListener('click', (e) => { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  /* ---------------- altri capi: consigli di Shopify ---------------- */
  $$('[data-recs]').forEach((sec) => {
    const track = $('[data-recs-track]', sec);
    if (!track || !sec.dataset.url) return;
    fetch(sec.dataset.url).then((r) => (r.ok ? r.text() : '')).then((html) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recs-track]', doc);
      if (fresh && fresh.children.length >= 2) {
        track.innerHTML = fresh.innerHTML;
        track.scrollLeft = 0;
        track.dispatchEvent(new Event('scroll'));
      }
    }).catch(() => {}).finally(() => { if (!track.children.length) sec.remove(); });
  });

  /* ---------------- descrizione: leggi tutto ---------------- */
  $$('[data-desc]').forEach((d) => {
    const body = $('.desc__body', d), btn = $('[data-desc-toggle]', d);
    if (!body || !btn) return;
    const check = () => { if (!d.classList.contains('is-open')) btn.hidden = body.scrollHeight <= body.clientHeight + 8; };
    check(); window.addEventListener('resize', check);
    btn.addEventListener('click', () => {
      const open = d.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Mostra meno' : 'Leggi tutto';
      if (!open) d.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  });

  /* ---------------- cursore con etichetta ---------------- */
  if (FINE && !REDUCED) {
    const cur = document.createElement('div');
    cur.className = 'cursor'; cur.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cur);
    let cx = -200, cy = -200, px = -200, py = -200, label = '';
    window.addEventListener('pointermove', (e) => {
      px = e.clientX; py = e.clientY;
      const host = e.target.closest && e.target.closest('[data-cursor]');
      const next = host && !e.target.closest('button, input, select, textarea, .rail-nav') ? host.dataset.cursor : '';
      if (next !== label) {
        label = next; cur.textContent = label; cur.classList.toggle('is-on', !!label);
        cur.classList.toggle('is-light', !!(host && host.closest('.stage, .section--dark')));
      }
    }, { passive: true });
    document.addEventListener('pointerleave', () => { label = ''; cur.classList.remove('is-on'); });
    onTick(() => {
      cx = lerp(cx, px, .2); cy = lerp(cy, py, .2);
      cur.style.setProperty('--cx', `${cx.toFixed(1)}px`); cur.style.setProperty('--cy', `${cy.toFixed(1)}px`);
    });
  }

  /* ---------------- passaggio animato verso la scheda prodotto ---------------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="/products/"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || !document.startViewTransition && !('onpageswap' in window)) return;
    const card = a.closest('.card, .stage__frame, .marquee__link');
    const img = card && (card.matches('.stage__frame') ? $('.stage__slide.is-active img', card) : $('img', card));
    $$('[style*="view-transition-name"]').forEach((n) => { n.style.viewTransitionName = ''; });
    if (img) { $$('.gallery__item:first-child img').forEach((n) => { if (n !== img) n.style.viewTransitionName = 'none'; }); img.style.viewTransitionName = 'piece'; }
  });
  window.addEventListener('pageshow', () => { $$('img').forEach((n) => { if (n.style.viewTransitionName) n.style.viewTransitionName = ''; }); });

  /* ---------------- domande e schede: apertura morbida ---------------- */
  if (!REDUCED) {
    $$('.faq details, .acc details').forEach((d) => {
      const sum = $('summary', d);
      const body = sum && sum.nextElementSibling;
      if (!body) return;
      let anim = null;
      sum.addEventListener('click', (e) => {
        e.preventDefault();
        if (anim) anim.cancel();
        const opening = !d.open;
        const start = d.offsetHeight;
        if (opening) d.open = true;
        const end = opening ? sum.offsetHeight + body.offsetHeight : sum.offsetHeight;
        d.style.overflow = 'hidden';
        anim = d.animate({ height: [`${start}px`, `${end}px`] }, { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' });
        anim.onfinish = () => { if (!opening) d.open = false; d.style.overflow = ''; anim = null; };
        anim.oncancel = () => { d.style.overflow = ''; };
      });
    });
  }

  /* ---------------- densità della griglia ---------------- */
  $$('[data-density]').forEach((grp) => {
    const grid = $('[data-grid]');
    if (!grid) return;
    const btns = $$('[data-cols]', grp);
    const apply = (v) => {
      grid.classList.toggle('is-large', v === 's');
      btns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.cols === v)));
    };
    let saved = null; try { saved = localStorage.getItem('omw-density'); } catch (_) {}
    if (saved) apply(saved);
    btns.forEach((b) => b.addEventListener('click', () => {
      apply(b.dataset.cols);
      try { localStorage.setItem('omw-density', b.dataset.cols); } catch (_) {}
    }));
  });

  /* ---------------- collezione: ordinamento e filtri ---------------- */
  $$('[data-autosubmit]').forEach((sel) => sel.addEventListener('change', () => sel.form.submit()));
})();
